var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "spreadPic",
                    label: "宣传图片",
                  },
                },
                [
                  _c("j-image-upload", {
                    attrs: { text: "上传宣传图片", isMultiple: true },
                    model: {
                      value: _vm.model.spreadPic,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "spreadPic", $$v)
                      },
                      expression: "model.spreadPic",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "spreadContent",
                    label: "宣传内容",
                  },
                },
                [
                  _c("a-textarea", {
                    attrs: { rows: "4", placeholder: "请输入宣传内容" },
                    model: {
                      value: _vm.model.spreadContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "spreadContent", $$v)
                      },
                      expression: "model.spreadContent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "spreadContent",
                    label: "链接地址",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { rows: "4", placeholder: "请输入链接地址" },
                    model: {
                      value: _vm.model.spreadLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "spreadLink", $$v)
                      },
                      expression: "model.spreadLink",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "投放日期",
                    labelCol: _vm.labelCol,
                    prop: "timeRange",
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("a-range-picker", {
                    attrs: { format: "YYYY-MM-DD" },
                    on: { change: _vm.dateChnage },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "投放时间段",
                    labelCol: _vm.labelCol,
                    prop: "timeRange",
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-time-picker",
                    {
                      attrs: { valueFormat: "HH:mm:ss" },
                      on: { change: _vm.timeRange1 },
                      model: {
                        value: _vm.model.startTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "startTime", $$v)
                        },
                        expression: "model.startTime",
                      },
                    },
                    [
                      _c("a-icon", {
                        attrs: { slot: "suffixIcon", type: "smile" },
                        slot: "suffixIcon",
                      }),
                    ],
                    1
                  ),
                  _vm._v("-\n        "),
                  _c(
                    "a-time-picker",
                    {
                      attrs: { valueFormat: "HH:mm:ss" },
                      on: { change: _vm.timeRange2 },
                      model: {
                        value: _vm.model.endTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "endTime", $$v)
                        },
                        expression: "model.endTime",
                      },
                    },
                    [
                      _c("a-icon", {
                        attrs: { slot: "suffixIcon", type: "smile" },
                        slot: "suffixIcon",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "visible",
                    label: "审核状态",
                  },
                },
                [
                  _c("j-dict-select-tag", {
                    attrs: { dictCode: "auditing_state" },
                    model: {
                      value: _vm.model.auditingState,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "auditingState", $$v)
                      },
                      expression: "model.auditingState",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "租户分配",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        mode: "multiple",
                        placeholder: "请选择租户分配",
                      },
                      model: {
                        value: _vm.currentTenant,
                        callback: function ($$v) {
                          _vm.currentTenant = $$v
                        },
                        expression: "currentTenant",
                      },
                    },
                    _vm._l(_vm.tenantList, function (item, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: item.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }